import { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Menu,
  MenuButton,
  MenuGroup,
  MenuList,
  Select,
  Text,
} from '@chakra-ui/react'
import moment from 'moment'
import DatePicker from 'react-datepicker'

const DateFilterType = {
  dateThisYear: 'This Year',
  dateLastYear: 'Last Year',
  dateThisMonth: 'This Month',
  dateLastMonth: 'Last Month',
  dateThisWeek: 'This Week',
  dateLastWeek: 'Last Week',
  dateBefore: 'Before',
  dateAfter: 'After',
  dateBetween: 'Between',
}

const DateFilterTypeKey = {
  dateThisYear: 'dateThisYear',
  dateLastYear: 'dateLastYear',
  dateThisMonth: 'dateThisMonth',
  dateLastMonth: 'dateLastMonth',
  dateThisWeek: 'dateThisWeek',
  dateLastWeek: 'dateLastWeek',
  dateBefore: 'dateBefore',
  dateAfter: 'dateAfter',
  dateBetween: 'dateBetween',
}

const DateFilter = ({ value, setValue, direction = 'column' }) => {
  const [filterType, setFilterType] = useState('')
  const [date1, setDate1] = useState('')
  const [date2, setDate2] = useState('')

  useEffect(() => {
    if (typeof value !== 'string' || !value) {
      setFilterType('')
      setDate1('')
      setDate2('')

      return
    }

    const match = value.match(/^type__(\w+)(?:--([\w-]+))?$/)

    if (!match) {
      setFilterType('')
      setDate1('')
      setDate2('')
      return
    }

    if (match[1]) {
      setFilterType(match[1])
    }

    if (match[2]) {
      const dateMatch = match[2].match(/(\d{2}-[A-Za-z]{3}-\d{4})(?:to(\d{2}-[A-Za-z]{3}-\d{4}))?/)
      if (dateMatch) {
        switch (match[1]) {
          case DateFilterTypeKey.dateBefore:
          case DateFilterTypeKey.dateAfter: {
            const date = moment(dateMatch[1], 'DD-MMM-YYYY', true)
            if (date.isValid()) {
              setDate1(date.toDate())
            }

            break
          }
          case DateFilterTypeKey.dateBetween: {
            const date1 = moment(dateMatch[1], 'DD-MMM-YYYY', true)
            const date2 = moment(dateMatch[2], 'DD-MMM-YYYY', true)
            if (date1.isValid() && date2.isValid()) {
              setDate1(date1.toDate())
              setDate2(date2.toDate())
            }

            break
          }
        }
      }
    }
  }, [value])

  const handleFilterTypeChange = (e) => {
    const newFilterType = e.target.value

    setFilterType(newFilterType)
    updateFilter(newFilterType, date1, date2)
  }

  const handleDate1Change = (date) => {
    setDate1(date)
    updateFilter(filterType, date, date2)
  }

  const handleDate2Change = (date) => {
    setDate2(date)

    updateFilter(filterType, date1, date)
  }

  const updateFilter = (filterType, date1, date2) => {
    switch (filterType) {
      case DateFilterTypeKey.dateThisYear:
      case DateFilterTypeKey.dateLastYear:
      case DateFilterTypeKey.dateThisMonth:
      case DateFilterTypeKey.dateLastMonth:
      case DateFilterTypeKey.dateThisWeek:
      case DateFilterTypeKey.dateLastWeek:
        setValue(`type__${filterType}`)
        break
      case DateFilterTypeKey.dateBefore:
      case DateFilterTypeKey.dateAfter: {
        if (!date1) {
          return
        }
        const formattedDate = moment(date1).format('DD-MMM-YYYY')
        setValue(`type__${filterType}--${formattedDate}`)
        break
      }
      case DateFilterTypeKey.dateBetween: {
        if (!date1 || !date2) {
          return
        }
        const formattedDate1 = moment(date1).format('DD-MMM-YYYY')
        const formattedDate2 = moment(date2).format('DD-MMM-YYYY')
        setValue(`type__dateBetween--${formattedDate1}to${formattedDate2}`)
        break
      }
    }
  }

  return (
    <Flex direction={direction} gap="2" alignItems={'center'}>
      <Select onChange={handleFilterTypeChange} placeholder="Select" value={filterType ?? ''}>
        {Object.entries(DateFilterType).map(([key, value]) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </Select>

      {['dateAfter', 'dateBefore', 'dateBetween'].includes(filterType) && (
        <Input as={DatePicker} dateFormat="dd-MMM-yyyy" selected={date1} onChange={handleDate1Change} minW="200px" />
      )}
      {['dateBetween'].includes(filterType) && (
        <>
          <Text px="2">To</Text>

          <Input as={DatePicker} dateFormat="dd-MMM-yyyy" selected={date2} onChange={handleDate2Change} minW="200px" />
        </>
      )}
    </Flex>
  )
}

export default DateFilter
